import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';

import AccountAx      from 'app/actions/account';
import EllipsisMenu   from 'app/components/common/ellipsis-menu';
import Icon           from 'app/components/common/icon';
import Wysiwyg        from 'app/components/common/rich-text/wysiwyg';
import StandardInput  from 'app/components/common/standard-input'
import AccountSlx     from 'app/selectors/account';
import FfSlx          from 'app/selectors/feature-flags';

const noop = () => {};
const dropdownIcon = <Icon.Cog1 />;

class RteEditor extends React.PureComponent {

  constructor(props) {
    super(props);

    this.refWysiwyg = React.createRef();
    this.refMdInput = React.createRef();

    this.state = {
      mode: (() => {
        const pref = props.prefs.rteMode;
        if (['wysiwyg', 'markdown'].includes(pref)) return pref;
        return 'wysiwyg';
      })(),
      md: props.initialMd,
    };

    this.onClickMd = this.onClickMd.bind(this);
    this.onClickWysiwyg = this.onClickWysiwyg.bind(this);
    this.onChangeMd = this.onChangeMd.bind(this);
    this.onChangeWysiwyg = this.onChangeWysiwyg.bind(this);
  }

  get isWysiwyg() {
    return this.state.mode === 'wysiwyg';
  }

  get vMsg() {
    return _.get(this.props.validations, `${this.props.name}[0]`) || null;
  }

  onClickMd(event) {
    event.preventDefault();
    this.setState({
      mode: 'markdown',
      md: this.refWysiwyg.current.md,
    });
    this.props.saveMode('markdown');
  }

  onClickWysiwyg(event) {
    event.preventDefault();
    this.setState({mode: 'wysiwyg'});
    this.props.saveMode('wysiwyg');
  }

  onChangeMd(event) {
    const md = event.target.value;
    this.setState({md});
    this.props.onChange(() => md);
  }

  onChangeWysiwyg(getMd) {
    this.props.onChange(getMd);
  }

  render() {
    const {placeholder, FfMd, name, validations} = this.props;
    const {md} = this.state;

    return (
      <div className={`rte-editor ${this.vMsg ? 'invalid' : ''}`}>
        {FfMd && (
          <EllipsisMenu className="rte-editor-settings" usePortal icon={dropdownIcon}>
            {this.isWysiwyg
              ? <a href="#" onClick={this.onClickMd}>switch to markdown</a>
              : <a href="#" onClick={this.onClickWysiwyg}>switch to rich text</a>
            }
          </EllipsisMenu>
        )}
        {this.isWysiwyg
          ? <Wysiwyg initialMd={md} onChange={this.onChangeWysiwyg} placeholder={placeholder} ref={this.refWysiwyg} />
          : <StandardInput className="rte-editor-md-input" onChange={this.onChangeMd} value={md} name={name} validations={validations} label={placeholder} type="textarea" ref={this.refMdInput} />
        }
        {!!(this.isWysiwyg && this.vMsg) && (
          <div className="validation-message">{this.vMsg}</div>
        )}
      </div>
    );
  }

}

RteEditor.propTypes = {
  initialMd: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  name: PropTypes.string,
  validations: PropTypes.object,
};

RteEditor.defaultProps = {
  initialMd: '',
  onChange: noop,
  placeholder: '',
  name: '',
  validations: null,
};

const stateToProps = (state) => ({
  prefs: AccountSlx.prefs(state),
  FfMd: FfSlx['rte-md'](state),
});

const dispatchToProps = (dispatch) => ({
  saveMode: (mode) => dispatch(AccountAx.setPrefs({rteMode: mode})),
});

export default connect(stateToProps, dispatchToProps)(RteEditor);
